import { render, staticRenderFns } from "./MaterialGroup.vue?vue&type=template&id=4664af8c&scoped=true&"
import script from "./MaterialGroup.vue?vue&type=script&lang=js&"
export * from "./MaterialGroup.vue?vue&type=script&lang=js&"
import style0 from "./MaterialGroup.vue?vue&type=style&index=0&id=4664af8c&prod&lang=less&"
import style1 from "./MaterialGroup.vue?vue&type=style&index=1&id=4664af8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4664af8c",
  null
  
)

export default component.exports